const ProfilePage = () => import('@/pages/profile/ProfilePage.vue')
const ProfileSummaryPage = () => import('@/pages/profile/ProfileSummaryPage.vue')
const ProfilePersonalPage = () => import('@/pages/profile/ProfilePersonalPage.vue')
const ProfileProfessionalPage = () => import('@/pages/profile/ProfileProfessionalPage.vue')
const ProfileAboutPage = () => import('@/pages/profile/ProfileAboutPage.vue')
const ProfileHobbiesPage = () => import('@/pages/profile/ProfileHobbiesPage.vue')
const ProfileContactsPage = () => import('@/pages/profile/ProfileContactsPage.vue')
const ProfileEducationsPage = () => import('@/pages/profile/ProfileEducationsPage.vue')
const ProfileLanguagesPage = () => import('@/pages/profile/ProfileLanguagesPage.vue')
const ProfileSkillsPage = () => import('@/pages/profile/ProfileSkillsPage.vue')
const ProfileInterviewPage = () => import('@/pages/profile/ProfileInterviewPage.vue')
const ProfileExperiencesPage = () => import('@/pages/profile/ProfileExperiencesPage.vue')
const ProfileRequirementsPage = () => import('@/pages/profile/ProfileRequirementsPage.vue')
const ProfileSearchInfoPage = () => import('@/pages/profile/ProfileSearchInfoPage.vue')

import interviewRoutes from '@/routes/interviews.js'

export default [
  {
    path: 'profile',
    name: 'profile',
    component: ProfilePage,
    meta: {
      layout: 'default',
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'profileSummaryPage',
        component: ProfileSummaryPage,
        meta: {
          layout: 'default',
          requiresAuth: true
        }
      },
      {
        path: 'professional',
        name: 'profileProfessionalPage',
        component: ProfileProfessionalPage,
        meta: {
          layout: 'default',
          requiresAuth: true
        }
      },
      {
        path: 'personal',
        name: 'profilePersonalPage',
        component: ProfilePersonalPage,
        meta: {
          layout: 'default',
          requiresAuth: true,
          isEdit: true
        }
      },
      {
        path: 'about',
        name: 'profileAboutPage',
        component: ProfileAboutPage,
        meta: {
          layout: 'default',
          requiresAuth: true,
          isEdit: true
        }
      },
      {
        path: 'hobbies',
        name: 'profileHobbiesPage',
        component: ProfileHobbiesPage,
        meta: {
          layout: 'default',
          requiresAuth: true,
          isEdit: true
        }
      },
      {
        path: 'contacts',
        name: 'profileContactsPage',
        component: ProfileContactsPage,
        meta: {
          layout: 'default',
          requiresAuth: true,
          isEdit: true
        }
      },
      {
        path: 'educations',
        name: 'profileEducationsPage',
        component: ProfileEducationsPage,
        meta: {
          layout: 'default',
          requiresAuth: true,
          isEdit: true
        }
      },
      {
        path: 'skills',
        name: 'profileSkillsPage',
        component: ProfileSkillsPage,
        meta: {
          layout: 'default',
          requiresAuth: true,
          isEdit: true
        }
      },
      {
        path: 'experiences',
        name: 'profileExperiencesPage',
        component: ProfileExperiencesPage,
        meta: {
          layout: 'default',
          requiresAuth: true,
          isEdit: true
        }
      },
      {
        path: 'languages',
        name: 'profileLanguagesPage',
        component: ProfileLanguagesPage,
        meta: {
          layout: 'default',
          requiresAuth: true,
          isEdit: true
        }
      },
      {
        path: 'request',
        name: 'profileRequirementsPage',
        component: ProfileRequirementsPage,
        meta: {
          layout: 'default',
          requiresAuth: true
        }
      },
      {
        path: 'search',
        name: 'profileSearchPage',
        component: ProfileSearchInfoPage,
        meta: {
          layout: 'default',
          requiresAuth: true
        }
      },
      {
        path: 'interviews',
        name: 'ProfileInterviewPage',
        component: ProfileInterviewPage,
        meta: {
          layout: 'default',
          requiresAuth: true
        }
      },
      { ...interviewRoutes }
    ]
  }
]
